import { cn } from '@/lib/utils';
import { STATUS_LABELS, STATUS_COLORS, type StatusSolicitacao } from '@/types/solicitacao';

interface SolicitacaoStatusBadgeProps {
  status: StatusSolicitacao;
  /**
   * Quando informado, "Aguardando Aprovação" e "Reprovada" têm
   * prioridade sobre o status (sobrescrevem label e cores).
   * Apenas "Aprovada" deixa o status normal aparecer.
   */
  estadoAprovacao?: string | null;
  className?: string;
}

// Normaliza: remove acentos, espaços, underscores e deixa lowercase.
const normalizeEstado = (v?: string | null) =>
  (v || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[\s_-]+/g, '')
    .toLowerCase();

export function SolicitacaoStatusBadge({
  status,
  estadoAprovacao,
  className,
}: SolicitacaoStatusBadgeProps) {
  const estado = normalizeEstado(estadoAprovacao);

  // Prioridade: Aguardando Aprovação ou Reprovada sobrescrevem o status
  if (estado === 'aguardandoaprovacao') {
    return (
      <span
        className={cn(
          'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium',
          // mesma paleta do Pendente
          'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400',
          className,
        )}
      >
        Aguardando Aprovação
      </span>
    );
  }

  if (estado === 'reprovada') {
    return (
      <span
        className={cn(
          'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium',
          // inverso do tema: preto no claro, branco no escuro
          'bg-black text-white dark:bg-white dark:text-black',
          className,
        )}
      >
        Reprovada
      </span>
    );
  }

  // Aprovada (ou não informado) -> status normal
  return (
    <span
      className={cn(
        'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium',
        STATUS_COLORS[status],
        className,
      )}
    >
      {STATUS_LABELS[status]}
    </span>
  );
}
